import axios from '../axios';

// 手机号维护
export const findAccountList = data => {
  return axios({
    url: '/tCyAccountConfig/findAccountList',
    method: 'post',
    data
  });
};

// 批量导入
export const updatePhone = data => {
    return axios({
        url: '/tCyAccountConfig/updatePhone',
        method: 'post',
        data
    });
};


// 下载模板
export const downModel = params => {
    return axios({
        url: '/tCyAccountConfig/downModel',
        method: 'get',
        responseType: 'blob',
        params
    });
};

// 导入失败下载
export const downloadErrorData = params => {
    return axios({
        url: '/tCyAccountConfig/downloadErrorData',
        method: 'get',
        responseType: 'blob',
        params
    });
};

// 上传
export const uploadExcel = data => {
    return axios({
        url: '/tCyAccountConfig/uploadExcel',
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data'},
        data
    });
};


// WEBPACK FOOTER //
// ./src/http/moudules/mobile.js